import HeaderPage from "../../components/HeaderPage";
import styles from "./faqpage.module.css";
export default function FAQPage() {
  return (
    <div>
      <HeaderPage />
      <div className={styles.container}>
        <main className={styles.main}>
          <section className={styles.section}>
            <h2>Frequently Asked Question</h2>
          </section>
          <section className={styles.section}>
            <h4>1. What is Bhive?</h4>
            <p>
              Bhive is your go-to online shop for the latest in fashion and
              accessories. We offer a wide range of clothing items for men,
              women, and children.
            </p>
          </section>
          <section className={styles.section}>
            <h4>2. How do I place an order?</h4>
            <p>
              To place an order, simply add items to your cart, proceed to
              checkout, and enter your shipping and payment information. You'll
              receive an email confirmation once your order is placed.
            </p>
          </section>
          <section className={styles.section}>
            <h4>3. What payment methods do you accept?</h4>
            <p>
              We accept various payment methods including credit/debit cards
              (Visa, MasterCard), PayPal, and Bhive gift cards.
            </p>
          </section>
          <section className={styles.section}>
            <h4>4. What is your return policy?</h4>
            <p>
              We offer a 30-day return policy on most items. Items must be in
              their original condition with tags attached. Please visit our
              return policy page for more details.
            </p>
          </section>
          <section className={styles.section}>
            <h4>5. Can I change my order after it has been placed?</h4>
            <p>
              Once an order is placed, it is immediately processed for shipment.
              If you need to make changes, contact our customer service team as
              soon as possible, and we will do our best to accommodate your
              request.
            </p>
          </section>
          <section className={styles.section}>
            <h4>6. What should I do if I receive a defective item?</h4>
            <p>
              If you receive a defective item, please contact our customer
              service team immediately with your order details and a photo of
              the defect. We will arrange for a replacement or refund.
            </p>
          </section>
          <section className={styles.section}>
            <h4>7. What is Bhive's loyalty program?</h4>
            <p>
              Our loyalty program rewards you for shopping with us. You earn
              points for every purchase, which can be redeemed for discounts on
              future orders. Sign up for an account to start earning points.
            </p>
          </section>
          <section className={styles.section}>
            <h4>8. How do I know if a clothing item will fit me well?</h4>
            <p>
              Besides checking the size guide, you can read customer reviews to
              see if other shoppers have mentioned how the item fits. If you’re
              unsure, consider ordering two sizes and returning the one that
              doesn’t fit.
            </p>
          </section>
          <section className={styles.section}>
            <h4>9. How are clothing items packaged for delivery?</h4>
            <p>
              Clothing items are carefully packaged to ensure they arrive in
              perfect condition. Each item is folded and placed in a protective
              bag before being shipped in a sturdy box or mailer.
            </p>
          </section>
          <section className={styles.section}>
            <h4>10. What should I do if I receive the wrong size or item?</h4>
            <p>
              If you receive the wrong size or item, please contact our customer
              service team immediately with your order details. We will arrange
              for an exchange or return.
            </p>
          </section>
        </main>
        <footer className={styles.footer}>
          <p>
            If you have any questions about these Terms, please contact us at{" "}
            <a href="mailto:support@bhive.com">support@bhive.com</a>.
          </p>
        </footer>
      </div>
    </div>
  );
}
